import React, { useContext } from "react";
import "../commonmodal.scss";

import { useTranslation } from "../../../contexts/TranslationProvider";
import EditContractTemplateContext from "../../../contexts/EditContractTemplateContext";

interface TemplateEditingModalPropos {
  onClose: () => void;
  onSave: () => void;
}

function TemplateEditingModal({ onClose, onSave }: TemplateEditingModalPropos) {
  const { contractTemplate, setContractTemplate } = useContext(EditContractTemplateContext);
  const { t } = useTranslation();

  const handleLanguageChange = (lang: "en" | "fr" | "ar") => {
    if (contractTemplate.languages.includes(lang)) {
      setContractTemplate({
        ...contractTemplate,
        languages: contractTemplate.languages.filter((l) => l !== lang),
      });
    } else {
      setContractTemplate({
        ...contractTemplate,
        languages: [...contractTemplate.languages, lang],
      });
    }
  };

  const handleRegionChange = (region: "FRA" | "TUN") => {
    if (contractTemplate.region?.includes(region)) {
      setContractTemplate({
        ...contractTemplate,
        region: contractTemplate.region.filter((r) => r !== region),
      });
    } else {
      setContractTemplate({
        ...contractTemplate,
        region: [...(contractTemplate.region || []), region],
      });
    }
  };

  const regions: { code: "FRA" | "TUN"; label: string }[] = [
    { code: "FRA", label: t("regions.france") },
    { code: "TUN", label: t("regions.tunisia") },
  ];

  const languages = [
    { code: "fr" as "en" | "fr" | "ar", label: t("languages.french") },
    { code: "ar" as "en" | "fr" | "ar", label: t("languages.arabic") },
    { code: "en" as "en" | "fr" | "ar", label: t("languages.english") },
  ];

  return (
    <>
      <div className="modal-backdrop"></div>
      <div id="contractz-lab">
        <div className="modal d-flex justify-content-center align-items-center">
          <div>
            <div className="modal-content shadow-lg rounded" style={{ width: "600px" }}>
              <div className="modal-header text-white">
                <h5 className="modal-title">{t("modals.regionLanguageContractTemplate.title")}</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={onClose}
                  aria-label={t("modals.regionLanguageContractTemplate.close")}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  {/* Language Selection */}
                  <div className="mb-4">
                    <h6 className="fw-bold">{t("modals.regionLanguageContractTemplate.languages")}</h6>
                    {languages.map((lang) => (
                      <div key={lang.code} className="form-check">
                        <input
                          type="checkbox"
                          id={`lang-${lang.code}`}
                          value={lang.code}
                          checked={contractTemplate.languages.includes(lang.code)}
                          onChange={() => handleLanguageChange(lang.code)}
                          className="form-check-input"
                        />
                        <label
                          htmlFor={`lang-${lang.code}`}
                          className="form-check-label"
                        >
                          {lang.label}
                        </label>
                      </div>
                    ))}
                  </div>

                  {/* Region Selection */}
                  <div className="mb-4">
                    <h6 className="fw-bold">{t("modals.regionLanguageContractTemplate.regions")}</h6>
                    {regions.map((region) => (
                      <div key={region.code} className="form-check">
                        <input
                          type="checkbox"
                          id={`region-${region.code}`}
                          value={region.code}
                          checked={contractTemplate.region?.includes(region.code) || false}
                          onChange={() => handleRegionChange(region.code)}
                          className="form-check-input"
                        />
                        <label
                          htmlFor={`region-${region.code}`}
                          className="form-check-label"
                        >
                          {region.label}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                >
                  {t("modals.regionLanguageContractTemplate.cancel")}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onSave}
                >
                  {t("modals.regionLanguageContractTemplate.save")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TemplateEditingModal;
